<template>
  <div class="container-water-fall">
    <waterfall :col="col" :data="data" @loadmore="loadmore">
      <div class="cell-item" v-for="(creative, index) in data" :key="index">
        <creativeItem
          :creative.sync="creative"
          :index="index"
          ref="creativeItem"
          @changeCreative="changeCreative"
          @openPreview="openPreview"
          @offerRecommended="$emit('offerRecommended', creative)"
          :ad_type_list="ad_type_list"
          :creative_category="creative_category"
        ></creativeItem>
      </div>
    </waterfall>
  </div>
</template>

<script type="text/javascript">
import creativeItem from './creativeItem'
export default {
  data() {
    return {
      data: [],
      col: 3,
      page: 1,
      over: false,
    }
  },
  props: {
    ad_type_list: {
      type: Array,
      default() {
        return []
      },
    },
    creative_category: {
      type: Array,
      default() {
        return []
      },
    },
    select_creative: {
      type: Object,
      default() {
        return {
          id: '',
        }
      },
    },
    initData: {
      type: Function,
    },
  },
  computed: {},
  created() {},
  mounted() {
    var divscroll = document.getElementById('vueWaterfall')
    var _self = this
    function divScroll() {
      var scrollTop = divscroll.scrollTop // 页面上卷的高度
      var wholeHeight = divscroll.scrollHeight // 页面底部到顶部的距离
      var divHeight = divscroll.clientHeight // 页面可视区域的高度
      if (scrollTop + divHeight >= wholeHeight) {
        _self.loadmore()
      }
    }
    divscroll.addEventListener('scroll', divScroll)
  },
  methods: {
    init() {
      this.getCol()
      window.onresize = this.getCol
      this.initData(this.page).then(data => {
        let datas = data.data
        if (this.data.length > 0) {
          this.data.forEach(item => {
            item.checked = false
            if (
              this.select_creative.hasOwnProperty('id') &&
              Number(this.select_creative.id) === item.id
            ) {
              item.checked = true
            }
          })
        }
        this.data = datas
      })
    },
    getCol() {
      let col = 3
      let w = document.documentElement.clientWidth
      if (w > 1920) {
        col = 5
      } else if (w > 1680) {
        col = 4
      } else if (w < 1280) {
        col = 2
      }
      this.col = col
    },
    openPreview(creative, type) {
      this.$emit('openPreview', creative, type)
    },

    changeCreative(value) {
      for (let i = 0; i < this.data.length; i++) {
        if (
          this.$refs['creativeItem'][i].creative.id !== value.id &&
          this.$refs['creativeItem'][i].creative.checked
        ) {
          this.$refs['creativeItem'][i].clear()
        }
      }
      this.$emit('changeCreative', value)
    },
    loadmore(num) {
      let index = ++this.page
      if (!this.over) {
        this.initData(index)
          .then(data => {
            let list = data.data
            if (data.data.length > 0) {
              list.forEach(item => {
                item.checked = false
                if (
                  this.select_creative.hasOwnProperty('id') &&
                  Number(this.select_creative.id) === item.id
                ) {
                  item.checked = true
                }
              })
              this.data = this.data.concat(data.data)
            } else {
              --this.page
              this.over = true
            }
          })
          .catch(error => {
            this.notifyOpen('Error', error.m, 'error')
          })
      }
    },
  },
  components: {
    creativeItem,
  },
}
</script>
<style lang="scss">
.container-water-fall {
  width: 100%;
  box-sizing: border-box;
  .vue-waterfall {
    overflow-x: hidden;
    height: 100vh;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 2rem;
  }
  .cell-item {
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    max-width: 288px;
    transition: 2s;
  }
}
</style>
